<template>
  <div class="feedbackMainTable">
    <div class="container">
      <div
        v-if="feedbackStatistics?.labels?.length && isDateCorrect"
        class="feedbackMainTable__totalCustomers"
      >
        <div class="numberOfUsers">
          <p>{{ $t('totalCustomersVotes') }}</p>
          <span>{{ feedbackStatistics?.tableData?.totalCustomers }}</span>
        </div>
        <div class="customersFeedback__totalCustomer-table">
          <TableFeedback
            :data="feedbackStatistics?.tableData?.totalByTypes"
            :columns="columns"
            :pickup-box-names="pickupBoxNames"
          />
        </div>
      </div>
      <div
        v-if="!feedbackStatistics?.labels?.length && isDateCorrect"
        class="totalCustomers__noData"
      >
        <p>{{ $t('noData') }}</p>
      </div>
    </div>
    <div
      v-if="
        dataPieChart &&
        dataPieChart.labels.length &&
        !dataPieChart.datasets[0].data.every((value) => !value)
      "
      class="pie-diagram"
    >
      <PieChart :data-pie-chart="dataPieChart" :style="stylePieChart" />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import { columns, defaultDataPieChart } from './configs';

@Options({
  name: 'FeedbackMainTable',
  props: ['feedbackStatistics', 'pickupBoxNames', 'isDateCorrect'],
  data() {
    return {
      columns: columns,
      height: 285,
      dataPieChart: defaultDataPieChart
    };
  },
  computed: {
    stylePieChart() {
      return {
        height: `${this.height}px`
      };
    }
  },
  methods: {
    initDataPieChart() {
      const totals =
        this.feedbackStatistics?.tableData?.totalByTypes?.total?.data || {};

      const labelsMap: Record<string, unknown> = {
        GOOD: this.$t('happy'),
        OK: this.$t('ok'),
        BAD: this.$t('angry')
      };

      const order = Object.keys(labelsMap);

      const data = order.map((key) => {
        const v = totals[key];

        return v;
      });

      this.dataPieChart = {
        labels: order.map((key) => labelsMap[key]),
        datasets: [
          {
            data,
            backgroundColor: ['#47987F', '#F19E37', '#E2523F'],
            borderColor: ['#47987F', '#F19E37', '#E2523F'],
            borderWidth: 0
          }
        ]
      };
    }
  },
  watch: {
    feedbackStatistics() {
      if (this.feedbackStatistics) {
        this.dataPieChart = { ...defaultDataPieChart };
        this.initDataPieChart();
      }
    }
  }
})
export default class FeedbackMainTable extends Vue {}
</script>

<style lang="scss" scoped>
.feedbackMainTable {
  display: flex;
  justify-content: flex-start;
  margin: 0 24px;
  .container {
    width: 600px;
    .feedbackMainTable__totalCustomers {
      .numberOfUsers {
        display: flex;
        p {
          font-size: $eighteenSize;
          font-family: 'Ubuntu-Medium';
        }
        span {
          font-size: $eighteenSize;
          font-family: 'Ubuntu-Medium';
          margin-left: 10px;
        }
      }
    }
  }
  .pie-diagram {
    width: 285px;
    height: 285px;
    padding: 20px;
    margin-left: 150px;
    border: 1px solid $border;
    border-radius: 8px;
  }
}
</style>
